var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.195312,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFD708"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.61 12.4574L9.98584 16.8734C9.84224 16.9692 9.64822 16.9304 9.55248 16.7868C9.51826 16.7354 9.5 16.6751 9.5 16.6134V7.78125C9.5 7.60866 9.63991 7.46875 9.8125 7.46875C9.87419 7.46875 9.93451 7.48701 9.98584 7.52123L16.61 11.9373C16.7536 12.033 16.7924 12.2271 16.6966 12.3707C16.6738 12.405 16.6443 12.4345 16.61 12.4574Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchVideo);
export default __webpack_public_path__ + "static/media/watch-video.e50713aedcdbf02c0b9d7a9876619ecc.svg";
export { ForwardRef as ReactComponent };